import * as bi from 'react-bootstrap-icons';
import { Button, Flex } from 'components';
import { monthToString } from 'common/helpers';
import { Icon } from 'shared/components';
import './style.scss';

interface IProps {
  date: Date;
  minDate: Date;
  onDateChange: (date: Date) => void;
  onMonthClick: () => void;
}

function StageDefaultHeader(props: IProps) {
  const handleNextMonthClick = () => {
    let year = props.date.getFullYear();
    let month = props.date.getMonth();
    let day = props.date.getDate();

    if (month === 11) {
      month = 0;
      year++;
    } else {
      month++;
    }

    const newDate = new Date(year, month, day);
    props.onDateChange(newDate);
  };

  const handlePrevMonthClick = () => {
    let year = props.date.getFullYear();
    let month = props.date.getMonth();
    let day = props.date.getDate();

    if (month === 0) {
      month = 11;
      year--;
    } else {
      month--;
    }

    const newDate = new Date(year, month, day);
    props.onDateChange(newDate);
  };

  const isPrevButtonDisabled =
    props.date.getFullYear() <= props.minDate.getFullYear() && props.date.getMonth() <= props.minDate.getMonth();
  const isNextButtonDisabled =
    props.date.getFullYear() >= props.minDate.getFullYear() + 2 && props.date.getMonth() >= 11;

  return (
    <Flex justifyContent='space-between'>
      <div />
      <Flex gap={5}>
        <Button
          color='transparent-blue'
          onClick={handlePrevMonthClick}
          disabled={isPrevButtonDisabled}
        >
          <Icon>
            <bi.ChevronLeft />
          </Icon>
        </Button>

        <Button
          color='transparent-blue'
          className='month-btn-KFHN'
          onClick={props.onMonthClick}
        >
          <span>
            {props.date.getFullYear()} — {monthToString(props.date.getMonth())}
          </span>
        </Button>

        <Button
          color='transparent-blue'
          onClick={handleNextMonthClick}
          disabled={isNextButtonDisabled}
        >
          <Icon>
            <bi.ChevronRight />
          </Icon>
        </Button>
      </Flex>
      <div />
    </Flex>
  );
}

export default StageDefaultHeader;
